/* Product cards: kits of one series differ in one or two parts, and side by side their titles read the same.
   Cards with the same title in the same grid are compared segment by segment (snippets/dnova-card-kit.liquid):
   the segments that set one apart come first, the ones every one of them carries are hidden. Runs again when
   a grid arrives later (product recommendations, filtering, infinite scroll). */
(() => {
  const titleOf = (kit) => {
    const card = kit.closest('.card-wrapper, .card, li') || kit.parentElement;
    const heading = card.querySelector('.card__heading');
    return heading ? heading.textContent.replace(/\s+/g, ' ').trim() : '';
  };
  const mark = () => {
    const groups = new Map();
    document.querySelectorAll('[data-dn-kit]').forEach((kit) => {
      const grid = kit.closest('ul, .grid, .slider, section') || document.body;
      const key = titleOf(kit);
      if (!key) return;
      if (!groups.has(grid)) groups.set(grid, new Map());
      const byTitle = groups.get(grid);
      if (!byTitle.has(key)) byTitle.set(key, []);
      byTitle.get(key).push(kit);
    });
    groups.forEach((byTitle) => byTitle.forEach((kits) => {
      const segs = kits.map((kit) => [...kit.querySelectorAll('.dn-card-kit__seg')]);
      const texts = segs.map((list) => new Set(list.map((s) => s.textContent.trim())));
      kits.forEach((kit, index) => {
        const list = segs[index];
        list.forEach((seg) => {
          const shared = kits.length > 1 && texts.every((set) => set.has(seg.textContent.trim()));
          seg.classList.toggle('is-common', shared);
          seg.classList.toggle('is-diff', kits.length > 1 && !shared);
        });
        // what differs first, in its own order; what every neighbour shares after it (hidden by CSS)
        if (kits.length > 1) [...list.filter((s) => !s.classList.contains('is-common')), ...list.filter((s) => s.classList.contains('is-common'))].forEach((s) => kit.append(s));
      });
    }));
  };
  let queued = 0;
  const schedule = () => { cancelAnimationFrame(queued); queued = requestAnimationFrame(mark); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver((records) => {
    if (records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-dn-kit]') || n.querySelector('[data-dn-kit]'))))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
